import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostAlertSubscriptionFormFields {

    public name: FormField
    public description: FormField
    public topic: FormField
    public datafeed: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          true,
          true,
          ""
        )
        this.topic = new FormField(
          'topic',
          'Topic',
          'topic',
          FormFieldType.pushedSelectionList,
          true,
        )
        this.datafeed = new FormField(
          'datafeed',
          'Datafeed',
          'datafeed',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostAlertSubscriptionFormFields()

export const postAlertSubscriptionFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  description: fields.description,
  topic: fields.topic,
  datafeed: fields.datafeed,
};